import { homeSecurityPortalApi } from 'data/axios';
import { TAddCameraPurchaseInfoRequest, TDeviceResponseType } from 'typings';
import { endpoints } from './endpoints';
import { ApiResponse } from './HttpRequest';

export async function getAllDeviceInSpace(
  spaceId: string
): Promise<ApiResponse<{ items: TDeviceResponseType[] }>> {
  const response = await homeSecurityPortalApi.get(
    endpoints.devicesInSpace(spaceId)
  );
  console.log('getAllDeviceBySpaceId', response);
  return response;
}

export const getAllMarketplaces = async (spaceId: string, deviceId: string) => {
  const response = await homeSecurityPortalApi.get(
    endpoints.getAllMarketplaces(spaceId, deviceId)
  );
  return response;
};

export const addCameraPurchaseInfo = async (
  spaceId: string,
  deviceId: string,
  data: TAddCameraPurchaseInfoRequest
) => {
  try {
    const response = await homeSecurityPortalApi.post(
      endpoints.addCameraPurchaseInfoRequest(spaceId, deviceId),
      data
    );
    return response;
  } catch (err) {
    console.log('Error in adding purchase info of camera', err);
    throw err;
  }
};

export interface AddDeviceToSubscriptionPayload {
  device_ids: string[];
}

export async function addDeviceToSubscription(
  subscriptionId: string,
  payload: AddDeviceToSubscriptionPayload
) {
  try {
    const response = await homeSecurityPortalApi.put(
      endpoints.addDeviceInSubscription(subscriptionId),
      payload
    );
    return response;
  } catch (error) {
    console.error('Error adding device to subscription:', error);
    throw error;
  }
}

export interface AuthenticateDevicePayload {
  name: string;
  pairing_status: 'Activated';
}

export async function AuthenticateDevice(
  spaceId: string,
  deviceId: string,
  payload: AuthenticateDevicePayload
) {
  try {
    const response = await homeSecurityPortalApi.patch(
      endpoints.authenticateDevice(spaceId, deviceId),
      payload
    );
    return response;
  } catch (error) {
    console.error('Error authenticating device:', error);
    throw error;
  }
}
